import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { concat, EMPTY, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { ForecastProductGroupModel } from '@/models/forecast-product-group.model';

export const fetchAllForecastProductGroupsEpic: PayloadEpic<void, ForecastProductGroupModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.forecastProductGroups.fetchAll.match),
        switchMap(() =>
            concat(
                of(actions.forecastProductGroups.setIsLoading(true)),
                fetchAllForecastProductGroups().pipe(
                    map(({ data }) => actions.forecastProductGroups.setAll(data.results)),
                    catchError((error) => {
                        console.error('fetchAllForecastProductGroupsEpic', error);

                        return EMPTY;
                    })
                ),
                of(actions.products.setIsLoading(false))
            )
        )
    );
};

const fetchAllForecastProductGroups = () => {
    return axios.get<ListResponse<ForecastProductGroupModel>>(`${apiEndpoints.forecastProductGroups()}`);
};
